import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _listInstagramAccountMediaRequest = {};
var _listInstagramAccountMediaResponse = { media: '_media' };
var _media = { timestamp: 'google.protobuf.Timestamp' };
function resolveWixInstagramV1InstagramMediaServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'instagram_integration.wixapps.net': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/instagram-accounts/v1',
                destPath: '/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/instagram-accounts/v1',
                destPath: '/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Get media from instagram account.
 *
 * Returns list of instagram media including all albums content.
 */
export function listInstagramAccountMedia(payload) {
    var _a = serializer(_listInstagramAccountMediaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listInstagramAccountMediaResponse, {
        _media: _media,
    }).fromJSON;
    function __listInstagramAccountMedia(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.instagram_feed.v1.instagram_media',
            method: 'GET',
            methodFqn: 'wix.instagram.v1.InstagramMediaService.ListInstagramAccountMedia',
            url: resolveWixInstagramV1InstagramMediaServiceUrl({
                protoPath: '/v1/instagram-accounts/media/{connectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listInstagramAccountMedia.fromReq = fromReq;
    __listInstagramAccountMedia.__isAmbassador = true;
    return __listInstagramAccountMedia;
}
//# sourceMappingURL=http.impl.js.map